import { IPaginable } from '@framework/ui';
import { Dispatch, useEffect } from 'react';
import { IUseSetPaginationUrlQuery } from './paginationUrlQuery';

export interface IApiMetaPaginazione {
  pagina?: number | null;
  limite?: number | null;
  totale?: number | null;
}

type SetPagination =
  | Dispatch<React.SetStateAction<IPaginable>>
  | IUseSetPaginationUrlQuery<IPaginable>;

export interface IPaginationPreviousOptions<T> {
  meta: IApiMetaPaginazione;
  data: T[];
  isLoading: boolean;
  pagination: IPaginable;
  setPagination: SetPagination;
}

/**
 * Custom hook che permette di caricare la pagina precedente
 * se la pagina corrente non presenta elementi.
 */
export function usePaginationPreviousPage<T>(
  options: IPaginationPreviousOptions<T>,
) {
  const { meta, data, isLoading, pagination, setPagination } = options;

  useEffect(() => {
    // Se la pagina non presenta elementi e non è la prima, allora carico la pagina precedente
    if ((meta?.pagina ?? 0) > 0 && data.length === 0 && !isLoading) {
      setPagination({ ...pagination, pagina: (meta?.pagina ?? 1) - 1 });
    }
  }, [data, meta, pagination, setPagination, isLoading]);
}
